import {
  postCall,
  QueryParamsInterface,
  HeadersInterface,
  BodyParamsInterface,
} from "./api";

export const login = async (email: string, password: string) => {
  let url = "auth/login";
  let body: BodyParamsInterface = [
    { name: "email", value: email },
    { name: "password", value: password },
  ];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response.data;
};

export const loginSocial = async (provider: string, token: string) => {
  let url = "auth/login/social";
  let body: BodyParamsInterface = [
    { name: "provider", value: provider },
    { name: "token", value: token },
  ];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response.data;
};

export const refreshToken = async (refreshToken: string) => {
  let url = "auth/refresh";
  let params: QueryParamsInterface | undefined;
  let headers: HeadersInterface = [
    { name: "Authorization", value: refreshToken },
  ];

  let response = await postCall(url, headers, params, undefined);
  return response.data;
};

export const register = async (
  username: string,
  email: string,
  password: string,
  password_confirmation: string
) => {
  let url = "auth/register";
  let body: BodyParamsInterface = [
    { name: "username", value: username },
    { name: "email", value: email },
    { name: "password", value: password },
    { name: "password_confirmation", value: password_confirmation },
  ];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response.data;
};

export const forgotPassword = async (email: string) => {
  let url = "auth/password/forgot";
  let body: BodyParamsInterface = [{ name: "email", value: email }];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response.data;
};

export const recoveryPassword = async (
  token: string,
  password: string,
  password_confirmation: string
) => {
  let url = "auth/password/reset";
  let body: BodyParamsInterface = [
    { name: "token", value: token },
    { name: "password", value: password },
    { name: "password_confirmation", value: password_confirmation },
  ];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response.data;
};
